var Size = /** @class */ (function () {
    function Size(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'width,height';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Size.prototype.toJSON = function () {
        return {
            "width": this.width,
            "height": this.height
        };
    };
    Size.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Size;
}());
export { Size };
//# sourceMappingURL=size.js.map